import React from 'react';
import HtmlComponent from '../../lessonPlayer/components/HtmlComponent';

const DefaultGraphicOrganizer = ({ model }) => {
  console.log('DefaultGraphicOrganizer model:', model);
  return (
    <div className='element-container' id={`_${model.id}`}>
      <div className='label-value-row'>
        <div>Graphic Organizer Type:</div>
        <div className='not-implemented'>{model.type} (*** not implemented yet ***)</div>
      </div>
      <div className='label-value-row'>
        <div>Question Number:</div>
        <div>{model.questionNumber}</div>
      </div>
      <div className='label-value-row'>
        <div>Point Value:</div>
        <div>{model.maxScore}</div>
      </div>
      <div className='label-value-row'>
        <div>Directions:</div>
        <div className='ckeditor-text'><HtmlComponent htmlStr={model.directions} /></div>
      </div>
    </div>
  );
};
export default DefaultGraphicOrganizer;
